import React from 'react';
import { compose, hoistStatics, withState, withHandlers, withProps, lifecycle } from 'recompose';
import { translate } from 'react-i18next';
import Select from './Select';
// https://hernansartorio.com/jquery-nice-select/

const $ = window.$;

class RefsStore { store(name, value) { this[name] = value; } }

const enhance = compose(
  translate('portal'),
  withState('isLoading', 'setIsLoading', true),
  withState('selected', 'setSelected', ''),
  withProps(props => ({
    optionList: props.optionList ? props.optionList : props.service.getList(props.type, props.t),
    refs: new RefsStore(),
  })),
  lifecycle({
    constructor() {
      this.select = React.createRef();
    },
    async componentDidMount() {
      $(this.props.refs.select).niceSelect();
      this.props.setIsLoading(false);
    },
    async componentWillUnmount() {
      $(this.props.refs.select).niceSelect('destroy');
    },
  }),
  withHandlers({
  }),
);

export default hoistStatics(enhance)(Select);



// WEBPACK FOOTER //
// ./src/components/form/niceSelect/index.js